class PdpToolbar extends HTMLElement {
  constructor() {
    super();

    this.isPddButtonVisible = false;

    this.pdpButtonElementWrap = document.querySelector(".product-form__buttons");
    this.pdpButtonElement = this.pdpButtonElementWrap.querySelector(".product-form__submit");

    this.removeWhenActiveElementAll = this.querySelectorAll("[data-remove-element-when-active]");

    this.buttonElement = this.querySelector("[data-pdp-toolbar-button]");

    this.init();
  }

  init() {
    if (!this.pdpButtonElementWrap) return;

    var intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.isPddButtonVisible = true;
        } else {
          this.isPddButtonVisible = false;
        }

        this.updateClass();
      });
    });

    intersectionObserver.observe(this.pdpButtonElementWrap);

    if (this.buttonElement) {
      this.buttonElement.addEventListener("click", () => this.pdpButtonElement.click());
    }
  }

  updateClass() {
    if (this.isPddButtonVisible) {
      this.classList.remove("is-active");
    } else {
      if (window.scrollY > this.pdpButtonElementWrap.offsetTop + this.pdpButtonElementWrap.offsetHeight) {
        this.classList.add("is-active");

        this.removeWhenActive();
      }
    }
  }

  removeWhenActive() {
    if (!this.removeWhenActiveElementAll.length) return;

    this.removeWhenActiveElementAll.forEach((element) => element.remove());
  }
}

customElements.define("pdp-toolbar", PdpToolbar);
